import * as React from 'react';

//components
import LeadImage from '../components/LeadImage.jsx';

//images
import lakeland from '../assets/img/sections/lakeland.jpeg';

const LakelandStory = () => {
  return (
    <section className="section" id="lakeland">
      <div className="wrapper" id="lakeland-wrapper">
        <LeadImage image={lakeland} text={''} />

        <h1 className="first-line">'It’s quietly dying’</h1>

        <p className="p-heading">
          A new cycle of redevelopment could threaten Lakeland and other
          historic College Park neighborhoods
        </p>

        <p>
          A short walk from the University of Maryland campus, still within
          range of the Memorial Chapel bell, sits a neighborhood full of stories
          from decades ago.
          <br />
          <br />
          Maxine Gross grew up in Lakeland, a neighborhood between Route 1 and
          Lake Artemesia. In the early 1900s, it was a flourishing
          African-American community developing in the shadows of a campus that
          did not admit black students.
          <br />
          <br />
          But urban renewal projects of the ’70s and ’80s pushed out many
          families and left the community forever changed. Today, Gross’
          neighborhood sits across from The Varsity apartment complex on Route
          1. And the area is poised for more changes, as the city around it
          works to attract development.
          <br />
          <br />
          “I’ll just speak for Lakeland — it’s quietly dying,” said Gross, the
          chairperson of the Lakeland Community Heritage Project.
          <br />
          <br />
          Gross, the sole woman and person of color on the board of the College
          Park City-University Partnership — which set into motion much of this
          development — graduated from this university in 1981. She remembers
          the community of the past.
          <br />
          <br />
          On a short walk through Lakeland, she pointed out the former homes of
          numerous relatives — as well as several homes enveloped by weeds and
          tall grasses, their facades worn by time and abandonment.
          <br />
          <br />
          “You saw some of those houses,” she said. “Is that what you want to
          move next to?”
          <br />
          <br />
          For young families looking for their first home, College Park is “a
          prime location,” Gross said. She laments that the condition of these
          houses has prevented so many from seeing that.
          <br />
          <br />
          “There’s no reason why young families wouldn’t be standing in line to
          move into any of those houses we saw,” she said. “Why isn’t that
          happening?”
          <br />
          <br />
          Supporting elderly residents in keeping up their property and offering
          mortgage payment and financial planning support for those in need are
          some ways to offset these challenges, Gross said.
          <br />
          <br />
          Some elements of the city’s goal of becoming a top-20 college town by
          2020 are going well, Gross said. She commended the partnership’s
          homeownership program — which provides up to $15,000 in zero-interest,
          forgivable loans to some city and university staffers — and said it
          should be expanded.
          <br />
          <br />
          But Gross said the partnership ought to balance its efforts to attract
          developers with measures that help current residents. Ensuring the
          existing community remains stable and diverse, in her view, will make
          the city more attractive to potential newcomers.
          <br />
          <br />
          “The types of supports that are given to … big-money developers,
          similar types of supports need to be given within communities,” she
          said. “Whether it be an absentee landlord or a[n] individual, how do
          you make it difficult for them not to keep up their house? Or how do
          you support them in being able to?”
          <br />
          <br />
          Other College Park residents outside Lakeland echo Gross' concerns.
          <br />
          <br />
          Kerry Snow, a longtime North College Park resident, said services such
          as parking and code enforcement have languished in recent years at the
          expense of the partnership’s vision.
          <br />
          <br />
          “There are some things that I think may be suffering because the city
          is trying to do so much with downtown,” said Snow, a three-time
          graduate of this university. “A lot of my neighbors complain about
          houses that are abandoned … and look like they’re going to crash to
          the ground.”
          <br />
          <br />
          Snow lives on a street with restricted parking due to its proximity to
          Route 1, so residents all have placards for their cars to allow them
          to park. Enforcement used to be routine, but now, it seems as though
          cars aren’t being checked as often, he said.
          <br />
          <br />
          Carol Macknis, a District 1 resident, shared similar feelings.
          <br />
          <br />
          “[The city is] so overwhelmed with trying to do things for the
          university and trying to make it a college town, they tend to forget
          about the residents,” she said.
          <br />
          <br />
          Despite the University Police expansion into a broader jurisdiction in
          2013, Macknis said public safety efforts in areas farther from the
          university and downtown area ought to be stronger. She decried the
          fact that the city’s proposed budget for the next fiscal year does not
          increase funds for public safety.
          <br />
          <br />
          College Park doesn’t have its own police force, relying on a contract
          with Prince George’s County police for area patrols. University Police
          brought on five new officers and new vehicles with their jurisdiction
          expansion.
          <br />
          <br />
          College Park District 2 Councilman P.J. Brennan said, ultimately, the
          development efforts will benefit residents, regardless of the
          potential inconveniences.
          <br />
          <br />
          “The city has very basic services and things that we can do to provide
          to the residents. Trash pickup is a huge part of our operation. Code
          enforcement is another huge part,” he said. “The work that we do to
          attract development isn’t to serve developers, it’s to serve the
          community and the future vision of our city.”
          <br />
          <br />
          Still, Macknis said the city’s efforts are misguided.
          <br />
          <br />
          “Other people who had come to College Park maybe 10 to 15 years ago,
          they come into College Park now and they say ‘It’s ridiculous,’” she
          said. “For some reason, the mayor is so focused on downtown and the
          university, I don’t think he can see the forest from the trees.”
        </p>
      </div>
    </section>
  );
};

export default LakelandStory;



// WEBPACK FOOTER //
// ./src/views/LakelandStory.jsx